<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.3323 25L6 21.8673V6L12.3323 9.13273V25Z" stroke="#000" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
<path d="M18.6699 21.8673L12.3345 25V9.13273L18.6699 6V21.8673Z" stroke="#000" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
<path d="M24.9978 25L18.6655 21.8673V6L24.9978 9.13273V25Z" stroke="#000" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
</svg>
